// src/components/Layout.js
import React, { useState } from 'react';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaidIcon from '@mui/icons-material/Paid';
import { NavLink } from 'react-router-dom';
import Footer from './Footer';

const drawerWidth = 200;

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevOpen) => !prevOpen);
  };

  const drawerContent = (
    <>
      <Toolbar />
      <List>
        <ListItem button component={NavLink} to="/dashboard">
          <ListItemIcon>
            <DashboardIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button component={NavLink} to="/att">
          <ListItemIcon>
            <EventAvailableIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Attendance" />
        </ListItem>
        <ListItem button component={NavLink} to="/bill">
          <ListItemIcon>
            <PaidIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Bill Book" />
        </ListItem>
        <ListItem button component={NavLink} to="/sales">
          <ListItemIcon>
            <PointOfSaleIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Credit Sales" />
        </ListItem>
        <ListItem button component={NavLink} to="/customers">
          <ListItemIcon>
            <StorefrontIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Customers" />
        </ListItem>
        <ListItem button component={NavLink} to="/sal">
          <ListItemIcon>
            <PaidIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Salary" />
        </ListItem>
        <ListItem button component={NavLink} to="/staff">
          <ListItemIcon>
            <SupervisorAccountIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Staff" />
        </ListItem>

       
        <ListItem button component={NavLink} to="/loan">
          <ListItemIcon>
            <AccountBalanceWalletIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Loans" />
        </ListItem>
        
        {/* <ListItem button component={NavLink} to="/sum">
          <ListItemIcon>
            <PaidIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Daily Summary" />
        </ListItem> */}
        {/* <ListItem button component={NavLink} to="/date">
          <ListItemIcon>
            <PaidIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Date range report" />
        </ListItem> */}
        {/* <ListItem button component={NavLink} to="/bill">
          <ListItemIcon>
            <PaidIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText primary="Bill Book" />
        </ListItem> */}
        {/* Add more navigation items as needed */}
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Toolbar>
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            PizzaHub LK
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Sidebar / Drawer */}
      {isMobile ? (
        // Temporary drawer on mobile
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      ) : (
        // Permanent drawer on desktop
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          open
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Instead of "width: calc(100% - drawerWidth)", we offset content by drawerWidth:
          ml: { sm: `${drawerWidth}px` },
          p: 3,
          backgroundColor: '#f5f5f5',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Push down content below AppBar */}
        <Toolbar />

        {/* Actual Page Content */}
        {children}

        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
